import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useAuth } from './useAuth';

/**
 * `/login` — auto-redirect to Keycloak.
 *
 * ProtectedRoute sends unauth'd users here with `state.from` set to the
 * original path so we can bounce back after the OIDC callback.
 */
export function LoginPage() {
  const { login } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  useEffect(() => {
    void login(from);
  }, [login, from]);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', p: 4 }}
    >
      <CircularProgress />
      <Typography color="text.secondary">Redirecting to sign in…</Typography>
    </Stack>
  );
}
